type MaximizeIconProps = {
  className?: string;
};

const MaximizeIcon = (props: MaximizeIconProps) => (
  <svg
    className={props.className !== undefined ? props.className : ""}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.17808 10.8206C9.25495 10.8975 9.29814 11.0018 9.29814 11.1105C9.29814 11.2192 9.25495 11.3235 9.17808 11.4004L3.88751 16.6909L7.53558 16.6904C7.64443 16.6904 7.74883 16.7336 7.8258 16.8106C7.90277 16.8875 7.94601 16.9919 7.94601 17.1008C7.94601 17.2096 7.90277 17.314 7.8258 17.391C7.74883 17.468 7.64443 17.5112 7.53558 17.5112L2.89795 17.5112C2.79001 17.5111 2.68648 17.4684 2.60984 17.3924L2.60636 17.3889C2.53274 17.3153 2.4881 17.2127 2.4881 17.1014L2.4881 12.4637C2.48802 12.3549 2.53116 12.2506 2.60802 12.1736C2.68488 12.0967 2.78918 12.0534 2.89795 12.0533C3.00673 12.0532 3.11108 12.0964 3.18805 12.1732C3.26502 12.2501 3.3083 12.3544 3.30838 12.4631L3.3078 16.1112L8.59837 10.8206C8.67525 10.7438 8.77951 10.7006 8.88822 10.7006C8.99694 10.7006 9.1012 10.7438 9.17808 10.8206Z"
      fill="#757575"
    />
    <path
      d="M10.8219 9.17935C10.7451 9.10248 10.7019 8.99822 10.7019 8.8895C10.7019 8.78078 10.7451 8.67652 10.8219 8.59965L16.1125 3.30906L12.4644 3.30964C12.3556 3.30964 12.2512 3.2664 12.1742 3.18943C12.0972 3.11246 12.054 3.00806 12.054 2.89921C12.054 2.79036 12.0972 2.68596 12.1742 2.60899C12.2512 2.53202 12.3556 2.48878 12.4644 2.48878L17.102 2.48878C17.21 2.48891 17.3135 2.53162 17.3902 2.60762L17.3936 2.6111C17.4673 2.68472 17.5119 2.78733 17.5119 2.89863L17.5119 7.53627C17.512 7.64505 17.4688 7.7494 17.392 7.82637C17.3151 7.90334 17.2108 7.94663 17.102 7.94671C16.9933 7.94678 16.8889 7.90365 16.812 7.82678C16.735 7.74992 16.6917 7.64563 16.6916 7.53685L16.6922 3.88877L11.4016 9.17935C11.3248 9.25623 11.2205 9.29942 11.1118 9.29942C11.0031 9.29942 10.8988 9.25623 10.8219 9.17935Z"
      fill="#757575"
    />
  </svg>
);

export default MaximizeIcon;
